export const getSearchParams = (url: string) => {
  const containsParams = url.indexOf('?') > -1;
  if (containsParams) {
    const params = {};
    const paramsStrArr = Array.isArray(url.split('?').slice(-1)) ? url.split('?').slice(-1)[0] : undefined;
    if (paramsStrArr) {
      const paramsArr = paramsStrArr.split('&');
      paramsArr.forEach((param) => {
        const innerParamArr = param?.split('=');
        if (Array.isArray(innerParamArr) && innerParamArr.length == 2) {
          params[innerParamArr[0]] = innerParamArr[1];
        }
      });
      return params;
    }
    return {};
  }
  return {};
};
